import * as ActionTypes from '../ActionTypes';

const initialBankState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    success: false,
    getEmployee: true,
};

export const EmployeeBankReducer = function (state = initialBankState, action) {
    switch (action.type) {
        case ActionTypes.GET_EMPLOYEE_BANK_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
                empBankData: []
            };
        case ActionTypes.GET_EMPLOYEE_BANK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                empBankData: action.payload?.data?.data
            };
        case ActionTypes.GET_EMPLOYEE_BANK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.ADD_EMPLOYEE_BANK_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.ADD_EMPLOYEE_BANK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                empBankData: action.payload?.data?.data
            };
        case ActionTypes.ADD_EMPLOYEE_BANK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.UPDATE_EMPLOYEE_BANK_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.UPDATE_EMPLOYEE_BANK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                empBankData: action.payload?.data?.data
            };
        case ActionTypes.UPDATE_EMPLOYEE_BANK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.DELETE_EMPLOYEE_BANK_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.DELETE_EMPLOYEE_BANK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                empBankData: action.payload?.data?.data
            };
        case ActionTypes.DELETE_EMPLOYEE_BANK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}